import { Button } from "components/ButtonNew";
import { CustomModal } from "components/CustomModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { EnergyAnalysisDashboardContent } from "./EnergyAnalysisDashboardContent";

type EnergyAnalysisDashboardProps = {
  className?: string;
  projectId: string;
};

export const EnergyAnalysisDashboard = ({ className, projectId }: EnergyAnalysisDashboardProps) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <div className={className}>
        <Button
          endIconName="Piechart"
          onClick={() => setModalOpen(true)}
          size="sm"
          startIconName="ChevronLeft"
          variant="tertiary"
        >
          {t("BuildingProfile.energyAnalysis.openDashboard")}
        </Button>
      </div>
      <CustomModal
        className="overflow-hidden !bg-lds-surface-muted"
        height="94vh"
        modalOpen={modalOpen}
        padding="0"
        setModalOpen={setModalOpen}
        width="97vw"
      >
        {modalOpen ? <EnergyAnalysisDashboardContent projectId={projectId} /> : null}
      </CustomModal>
    </>
  );
};
